// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__3Cjbw","placeholder":"style_placeholder__7bjEV","counter-wrap":"style_counter-wrap__1-6lp","button":"style_button__1gm1L","counter":"style_counter__2_SQQ"};